import { Link, LinkProps, useLocation } from 'react-router-dom';

export const LocationLink = ({ state, ...props }: LinkProps) => {
  const location = useLocation();
  const from = `${location.pathname}${location.search}`;
  const linkState = typeof state === 'object' && state !== null ? state : {};

  return (
    <Link
      {...props}
      state={{
        ...linkState,
        from,
      }}
    />
  );
};
